module.exports = __webpack_public_path__ + "img/logov1.8a0be7b9.png";